module.exports = __webpack_public_path__ + "static/media/logo-kopa.0c7eab35.svg";